// @flow
import React from 'react';
import AuthService from './Auth.service';

export default React.createContext<typeof AuthService | null>(null);
